import React from 'react';
import T from 'prop-types';
import { mapValues, pickBy } from 'lodash-es';

import { SmartChart } from '../../../../components/Chart';
import Skeleton from '../../../../components/Skeleton';
import { columnChartConfig } from './config';
import { advancedPartialFilters } from '../../configs/chart-config';

const TsPenetrationChart = ({ metricOption, series, isPending }) => {
  const metricSeries = pickBy(series, (_, key) => key === `${metricOption.value}_change`);

  const metaSeries = mapValues(metricSeries, () => ({
    name: metricOption.label,
    color: '#348BE3',
    visible: true,
    type: 'column',
  }));

  const chartConfig = columnChartConfig({
    series: metricSeries,
  });

  return (
    <div className="ts-penetration-chart">
      {isPending ? (
        <Skeleton height={266} className="d-flex" />
      ) : (
        <SmartChart
          chartId="ts-penetration-chart"
          series={metricSeries}
          metaSeriesData={metaSeries}
          config={chartConfig}
          allowPartialPeriods
          filters={advancedPartialFilters}
        />
      )}
    </div>
  );
};

TsPenetrationChart.propTypes = {
  metricOption: T.shape({
    value: T.string,
    label: T.string,
  }).isRequired,
  series: T.object,
  isPending: T.bool,
};

export default TsPenetrationChart;
